import { Pipe, PipeTransform } from '@angular/core';

import { BACKGROUND_CLASS_MAP, BackgroundColors } from './section-class.types';

@Pipe({ name: 'sectionBgClass', standalone: true, pure: true })
export class SectionBgClass implements PipeTransform {
	transform(input: BackgroundColors): string {
		return BACKGROUND_CLASS_MAP[input] ?? BACKGROUND_CLASS_MAP['white'];
	}
}
